import { transformToCdnUrl } from 'utils/google-storage-util';
import base from './tile-art.module.css';
import styles from './TranslationsTileArt.module.css';

export const TranslationsTileArt: React.FC = () => (
    <>
        <img
            className={`${base.layer} ${styles.flag} ${styles.flagLeft}`}
            src={transformToCdnUrl('embedded-assets/tiles/ro-flag.webp')}
            width={488}
            height={320}
            alt=""
            aria-hidden="true"
            loading="lazy"
        />
        <img
            className={`${base.layer} ${styles.flag} ${styles.flagRight}`}
            src={transformToCdnUrl('embedded-assets/tiles/hu-flag.webp')}
            width={488}
            height={320}
            alt=""
            aria-hidden="true"
            loading="lazy"
        />
        <img
            className={`${base.layer} ${styles.flag} ${styles.flagCenter}`}
            src={transformToCdnUrl('embedded-assets/tiles/uk-flag.webp')}
            width={488}
            height={320}
            alt=""
            aria-hidden="true"
            loading="lazy"
        />
    </>
);
